var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.687 130C154.445 133.811 160.105 142.452 160.105 151.998V232H488C501.25 232 512 242.75 512 256C512 269.25 501.25 280 488 280H160.105V360C160.105 369.547 154.445 378.188 145.687 382.002C136.934 385.813 126.738 384.079 119.75 377.594L7.676 273.594C-2.559 264.094 -2.559 247.905 7.676 238.407L119.75 134.405C126.738 127.92 136.934 126.186 145.687 130Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLong);
export default __webpack_public_path__ + "static/media/left-long.22deded8c61ed295d593095c3369fbe2.svg";
export { ForwardRef as ReactComponent };